// extracted by mini-css-extract-plugin
export default {"contentSection":"ContentSection_contentSection__oPbaw","sectionTitle":"ContentSection_sectionTitle__NyPey","sectionContent":"ContentSection_sectionContent__qmZxH"};